import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlService } from './url.service';
import { OrganizationDto } from 'app/@types/dto/organization-dto.model';
import { OnboardingDto } from 'app/@types/dto/onboarding-dto.model';
import { BYPASS_ERROR } from 'app/auth/helpers';
import { UserInfoDto } from 'app/@types/dto/user-info-dto.model';

@Injectable({
    providedIn: 'root',
})
export class UserHttpService {
    constructor(private http: HttpClient, private urlService: UrlService) {}

    updateOrganization(orgId: string, org: OrganizationDto, isOnboarding: boolean): Observable<OrganizationDto> {
        return this.http.put<OrganizationDto>(this.urlService.updateOrganization(orgId, isOnboarding), org);
    }

    initUser(onboarding: OnboardingDto, clientName: string): Observable<any> {
        return this.http.post(this.urlService.postRegister(clientName), onboarding, {
            context: new HttpContext().set(BYPASS_ERROR, true),
        });
    }

    getAvailableOrganization(): Observable<OrganizationDto[]> {
        return this.http.get<OrganizationDto[]>(this.urlService.getAvailableOrganization());
    }

    getUserByOrganization(orgId: string): Observable<UserInfoDto[]> {
        return this.http.get<UserInfoDto[]>(this.urlService.getUserByOrganization(orgId));
    }

    addUserToScan(user: UserInfoDto) {
        return this.http.put(this.urlService.addUserToScan(), user);
    }

    updateUser(user: UserInfoDto) {
        return this.http.put<UserInfoDto>(this.urlService.updateUser(), user);
    }

    updateCognitoUser(user: UserInfoDto) {
        return this.http.put<UserInfoDto>(this.urlService.updateCognitoUser(user), user);
    }

    removeUser(orgId: string, userId: string) {
        return this.http.delete(this.urlService.removeUser(orgId, userId));
    }
}
